import type { AuthSessionResponse } from "@yagni/shared";
import { useAuthSession } from "./useWorkspaceRole.js";

/**
 * Read a feature flag value from the current session.
 * Session flags are a snapshot — they refresh on session reload (app boot,
 * workspace switch). Toggles in God Mode are not pushed live.
 *
 * Reads the session the way every surface does (`useAuthSession`), so a flag
 * read in the shell's sheet or the Ask dock sees the same session as the page.
 */
export function useFeatureFlag(key: string): boolean {
  return Boolean(useAuthSession()?.featureFlags?.[key]);
}

/**
 * Non-hook helper for code that receives `session` as a prop (or otherwise
 * has it in hand) rather than reading from outlet context.
 */
export function resolveFeatureFlag(
  session: AuthSessionResponse | null | undefined,
  key: string,
): boolean {
  return Boolean(session?.featureFlags?.[key]);
}
